import { AxiosResponse } from 'axios';
import { API } from '@invideoio/web-shared/lib/API';
import { ConfigType, ToolsRootResponseType } from '../../types';
import { FeatureConfig } from '@invideoio/web-shared/types/Config';

export async function fetchSocialLinks() {
  const configURL = `${process.env.NEXT_PUBLIC_CONFIG_URL}`;
  // @ts-ignore
  const response: AxiosResponse<ConfigType> = await API.get(configURL);
  const { data: configs } = response;
  const { social } = configs;

  return social;
}

export async function fetchConfig() {
  const configURL = `${process.env.NEXT_PUBLIC_CONFIG_URL}`;
  // @ts-ignore
  const response: AxiosResponse<ConfigType> = await API.get(configURL);
  const { data: config } = response;

  return config;
}

export async function getToolsPage(slug: string, lang = 'en') {
  // @ts-ignore
  const response: AxiosResponse<any[]> = await API.get(
    `${process.env.NEXT_PUBLIC_STRAPI_API_URL}${process.env.NEXT_PUBLIC_TOOLS_PAGE_CMS_ENDPOINT}?Slug_eq=${slug}&_locale=${lang}`,
  );

  if (!!response?.data && response.data.length > 0) {
    return response.data[0];
  }
}

export async function getToolsRootPage(lang = 'en') {
  try {
    // @ts-ignore
    const response: AxiosResponse<ToolsRootResponseType> = await API.get(
      `${process.env.NEXT_PUBLIC_STRAPI_API_URL}/tools-root?_locale=${lang}`,
    );
    return response.data;
  } catch (errors) {
    console.error(errors);
    throw new Error('Failed to fetch API');
  }
}

export async function getCompressPage(slug: string, lang = 'en') {
  // @ts-ignore
  const response: AxiosResponse<any[]> = await API.get(
    `${process.env.NEXT_PUBLIC_STRAPI_API_URL}/compresses?Slug_eq=${slug}&_locale=${lang}`,
  );

  if (!!response?.data && response.data.length > 0) {
    return response.data[0];
  }
}

export async function getConvertPage(slug: string, lang = 'en') {
  // @ts-ignore
  const response: AxiosResponse<any[]> = await API.get(
    `${process.env.NEXT_PUBLIC_STRAPI_API_URL}/converts?Slug_eq=${slug}&_locale=${lang}`,
  );

  if (!!response?.data && response.data.length > 0) {
    return response.data[0];
  }
}

export async function getPreviewableContent(
  id: string,
  contentType: string,
  lang = 'en',
) {
  try {
    // @ts-ignore
    const response: AxiosResponse<any[] | Record<string, any>> = await API.get(
      `${process.env.NEXT_PUBLIC_STRAPI_API_URL}/${contentType}?id_eq=${id}&_publicationState=preview&_locale=${lang}`,
    );

    if (
      !!response?.data &&
      Array.isArray(response?.data) &&
      response.data.length > 0
    ) {
      return response.data[0];
    }

    if (!!response?.data) {
      return response.data;
    }

    throw new Error('No data found on API');
  } catch (errors) {
    console.error(errors);
    throw new Error('Failed to fetch API');
  }
}

export async function fetchFeatureJson(): Promise<FeatureConfig | null> {
  const response = await API.get(
    String(process.env.NEXT_PUBLIC_FEATURE_JSON_URL),
  );

  if (response.data) {
    return response.data as Promise<FeatureConfig>;
  } else {
    return null;
  }
}

export async function sendEmailCampaign(data: {
  data: string;
}): Promise<boolean> {
  try {
    const response = await API.post(
      `${process.env.NEXT_PUBLIC_API_URL}/v3/send_user_campaign`,
      data,
    );

    if (response.data) {
      return response.data;
    } else {
      return false;
    }
  } catch (error) {
    console.log(error);

    return false;
  }
}
